import { createSelector } from 'reselect'

import { fromMobileSelector, canShareMobileSelector } from './mobile'

export const canShareSelector = createSelector(
  [fromMobileSelector(), canShareMobileSelector],
  (fromMobile, canShareMobile) => !fromMobile || canShareMobile
)
